import {
  Modal,
  ModalBody,
  ModalHeader,
} from 'component_library/2_Molecules/Modal'
import SlotGridHeader from './SlotGridHeader'
import styles from './index.module.scss'

import SlotGridBody from './SlotGridBody'
import { useEffect, useRef, useState } from 'react'

type SlotGridModalProps = {
  showModal: boolean
  onHide: () => void
  providerDetails: Provider
  userSelectedAvailType?: ProviderFilter[]
  groupedFilters?
  showFloralsBehindTheImage?: boolean
  selectedSlot?: SelectedSlot
  appointmentMode?: string
  renderCustomHeader?: () => JSX.Element
  renderCustomBody?: () => JSX.Element
  showProviderCreds?: boolean
  showSlotAndSessionInfo?: boolean
  modalHeadClassOverride?: string
  modalBodyClassOverride?: string
  slotLocation?: string
}

const SlotGridModal: React.FC<SlotGridModalProps> = ({
  showModal,
  onHide,
  providerDetails,
  userSelectedAvailType,
  groupedFilters,
  showFloralsBehindTheImage,
  selectedSlot,
  appointmentMode = '',
  showProviderCreds = true,
  showSlotAndSessionInfo = false,
  renderCustomHeader,
  renderCustomBody,
  modalHeadClassOverride = '',
  modalBodyClassOverride = '',
  slotLocation,
}) => {
  const [showShadow, setShowShadow] = useState<boolean>(false)
  const slotGridBodyRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleScroll = () => {
      if (
        slotGridBodyRef.current !== null &&
        slotGridBodyRef.current.scrollTop > 1
      ) {
        setShowShadow(true)
      } else {
        setShowShadow(false)
      }
    }

    slotGridBodyRef?.current?.addEventListener('scroll', handleScroll)

    return () => {
      slotGridBodyRef?.current?.removeEventListener('scroll', handleScroll)
    }
  }, [slotGridBodyRef?.current?.scroll])

  return (
    <Modal
      show={showModal}
      onHide={onHide}
      modalContentClass={styles.SlotGridModal_content}
    >
      <ModalHeader
        showCloseButton={true}
        showDivider={false}
        headerClassName={`${styles.ModalHeader_container} ${modalHeadClassOverride}`}
      >
        {renderCustomHeader ? (
          renderCustomHeader()
        ) : (
          <SlotGridHeader
            providerDetails={providerDetails}
            selectedSlot={selectedSlot}
            appointmentMode={appointmentMode}
            showShadow={showShadow}
            showSlotAndSessionInfo={showSlotAndSessionInfo}
            showProviderCreds={showProviderCreds}
            showFloralsBehindTheImage={showFloralsBehindTheImage}
          />
        )}
      </ModalHeader>
      <ModalBody
        ref={slotGridBodyRef}
        className={`${styles.ModalBody_container} ${modalBodyClassOverride}`}
      >
        {renderCustomBody ? (
          renderCustomBody()
        ) : (
          <SlotGridBody
            providerDetails={providerDetails}
            showModal={showModal}
            userSelectedAvailType={userSelectedAvailType}
            groupedFilters={groupedFilters}
            slotLocation={slotLocation}
          />
        )}
      </ModalBody>
    </Modal>
  )
}

export default SlotGridModal
